export const INCOME = 'income'